/* eslint-disable react/prop-types */
import { PureComponent } from 'react';

export default class SidebarSwitch extends PureComponent {
  render() {
    return this.props.children
  }
}
